<template>
  <!-- 店铺提现审核 -->
  <section class="draw">
    <!--工具条-->
    <el-col :span="24" class="draw_toolbar toolbar pad_left">
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <p style="margin: 0;margin-left: -22px;" class="goodslist1">
          <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
          <span class="goods_red"/>
        </p>
        <div style="position: absolute;right:-19px;top:-10px" class="sanjiao"></div>
      </div>
      <el-collapse-transition>
      <div style="padding:0 12px" v-show="show3">
        <el-form class="findform" style="margin-top:10px;display:flex;">
          <!-- 顶部搜索框 -->
          <el-form-item style="display:flex;width:32%" label="提现编号：">
            <el-input style="width:100%" v-model="filters.transferNum" placeholder="提现编号"/>
          </el-form-item>
          <el-form-item style="display:flex;width:32%;margin-left:10px" label="手机号码：">
            <el-input style="width:100%" v-model="filters.userTel" placeholder="手机号码"/>
          </el-form-item>
          <el-form-item style="display:flex;width:32%;margin-left:10px" label="收款方名称：">
            <el-input style="width:100%" v-model="filters.payeeName" placeholder="收款方名称"/>
          </el-form-item>
        </el-form>
        <el-form class="findform" style="display:flex;position: relative;">
          <el-form-item style="display:flex;width:32%" label="申请时间：">
            <el-date-picker type="daterange" :title="value6" v-model="value6" style="width:100%;cursor:pointer" value-format="yyyy-MM-dd"
              range-separator="至" start-placeholder="开始日期" @change="changetime" end-placeholder="结束日期"/>
          </el-form-item>
          <el-form-item style="display:flex;width:32%;margin-left:10px" label="审核状态：">
            <el-select v-model="filters.dataStatusCode" placeholder="请选择" style="background:#fff;width:100%" ref="mySelect">
              <el-option :label="item.Name" :value="item.Id" v-for="(item,index) in dataStatusCodeArr" :key="index"/>
            </el-select>
          </el-form-item>
          <el-form-item style="position: absolute;top:0;right:0">
            <el-button style="height:36px;line-height:1px" @click="onSubmit" class="toolbar_search">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    </el-col>

    <!--列表-->
    <template>
      <el-col :span="24" class="draw_table pad_left">
        <section class="model_section">
          <p class="model_top_title">店铺提现审核</p>
          <el-button type="danger" @click="editFormVisible()" style="float: right;margin: 5px 10px 0 0;">批量审核</el-button>
        </section>
        <div class="table_container" style="margin-top:10px">
          <div class="table_inner_container">
            <el-table :data="withdrawalList" class="draw_tab" stripe border
            @selection-change="handleSelectionChange" style="height:auto;max-height:500px" >
              <el-table-column type="selection" :selectable='selectInit' align="center"/>
              <el-table-column prop="num" label="序号" align="center" width="68px">
                <template scope="scope">{{scope.$index + 1}}</template>
              </el-table-column>
              <el-table-column label="提现编号" align="center" width="150px">
                <template scope="scope">{{scope.row.transferNum}}</template>
              </el-table-column>
              <el-table-column label="用户" align="center" width="110px">
                <template scope="scope">{{scope.row.userTel}}</template>
              </el-table-column>
              <el-table-column label="申请时间" align="center" width="150px">
                <template scope="scope">{{scope.row.createTime}}</template>
              </el-table-column>
              <el-table-column label="可提现金额(元)" align="center" width="110px">
                <template scope="scope">
                  <span class="spanList" :title="scope.row.allowTransferAmount">{{scope.row.allowTransferAmount}}</span>
                </template>
              </el-table-column>
              <el-table-column label="本次提现金额(元)" align="center" width="120px">
                <template scope="scope">{{scope.row.thisTransferAmount}}</template>
              </el-table-column>
              <el-table-column label="收款类型" align="center">
                <template scope="scope">{{scope.row.accountTypeName}}</template>
              </el-table-column>
              <el-table-column label="收款方名称" align="center" width="120px">
                <template scope="scope">{{scope.row.payeeName}}</template>
              </el-table-column>
              <el-table-column label="审核状态" align="center" width="120px">
                <template scope="scope">{{scope.row.dataStatusDesc.replace('/待打款','')}}</template>
              </el-table-column>
              <el-table-column label="审核意见" align="center" width="100px">
                <template scope="scope">
                  <span class="spanList" :title="scope.row.examineDesc">{{scope.row.examineDesc}}</span>
                </template>
              </el-table-column>
              <el-table-column label="审核时间" align="center" width="150px">
                <template scope="scope">{{scope.row.examineTime}}</template>
              </el-table-column>
              <el-table-column label="操作" fixed="right" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.dataStatusCode == 1" class="handle" @click="shenheedit(scope.row)">
                    <i class="el-icon-s-check"></i>审核
                  </span>
                  <span class="handle ac_btn_fail" v-else>
                    <i class="el-icon-s-check"></i>审核
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" style="padding-top:10px;" class="toolbar_footer">
              <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
                :page-size="10" :total="total" :current-page="pageInfo.pageNum" style="float:right;"/>
            </el-col>
          </div>
        </div>
      </el-col>
    </template>
    
    <!-- 批量审核界面 -->
    <el-dialog title="批量提现审核" :center="true" :visible.sync="shenFormVisble" width="622px">
      <el-form>
        <el-form-item>
          <el-input type="textarea" placeholder="请输入审核备注" maxlength="15" v-model="shenmark" :rows="3"/>
        </el-form-item>
      </el-form>
      <div  style="padding-left:0;text-align:center">
        <el-button type="danger" @click="billSubmit(2)">驳 回</el-button>
        <el-button type="danger" @click="billSubmit(3)">通 过</el-button>
      </div>
    </el-dialog>
    
    <!-- 提现审核-弹框 -->
    <el-dialog title="提现审核" :visible.sync="isToExamine" :center="true" width="60%">
      <div style="margin-bottom: 20px;">
        <span>店铺名称：<b>{{shopName}}</b></span>
      </div>
      <el-table :data="toExamineList" style="margin: 0px">
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column property="createTime" label="交易时间" align="center"/>
        <el-table-column property="orderNum" label="商户订单号" align="center"/>
        <el-table-column property="orderPayStatusDesc" label="交易状态" align="center"/>
        <el-table-column property="payChannelDesc" label="交易通道" align="center"/>
        <el-table-column property="orderAmount" label="订单金额(元)" align="center"/>
        <el-table-column property="thisTransferAmount" label="可提现金额(元)" align="center"/>
      </el-table>
      <el-col :span="24" style="padding-top:10px;" class="toolbar_footer">
        <el-pagination layout="prev, pager, next" @current-change="handleElCol"
          :page-size="10" :total="toExamineTotal" :current-page="toExaminePage.pageNum" style="float:right;"/>
      </el-col>
      <!-- 弹框按钮 -->
      <div class="btnDiv">
        <div style="width: 50%" class="elFormClass">
          <el-input type="textarea" placeholder="请输入审核备注" maxlength="15" v-model="shenmark" :rows="3"/>
        </div>
        <div style="width: 50%" class="elFormClass">
          <b>申请提现金额: {{money}}元</b>
          <button type="button" @click="billSubmit(3)" class="el-button search_btn">通过</button>
          <button type="button" @click="billSubmit(2)" class="el-button cancle">驳回</button>
        </div>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import { postTransferAccountsVerifyList, postTransferAccountsVerify, getTransferOrderNumsInfo } from "../../api/comment";
export default {
  data() {
    return {
      show3: false,
      filters: {
        transferNum: '', // 提现编码
        userTel: "", // 手机号码
        payeeName: "", // 收款方姓名
        createDateB: "", // 日期开始日期
        createDateE: "", // 日期结束日期
        dataStatusCode: '', // 审核状态
      },
      value6: '', // 申请时间
      dataStatusCodeArr: [
        {
          Id: '',
          Name: "全部"
        },
        {
          Id: '1',
          Name: "待审核"
        },
        {
          Id: '2',
          Name: "审核通过"
        },
        {
          Id: '3',
          Name: "审核未通过"
        }
      ],
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
      },
      withdrawalList: [], // 提现列表
      total: 1,
      shenFormVisble: false, // 审核弹窗
      tixianshenid: "", // 审核id
      shenmark: "", // 审核意见
      batchliveListArr:[], // 复选框选中项
      
      isToExamine: false, // 弹框
      toExamineList: [], // 审核列表
      toExaminePage: {
        pageNum: 1,
        pageSize: 10,
      },
      newParam: {
        transferNum: 0
      },
      toExamineTotal: 0,
      shopName: '', // 店铺名称
      money: 0, // 申请提现金额
      
    };
  },
  methods: {
    // 店铺提现审核
    init() {
      var addParams = {
        pageInfo: this.pageInfo, // 页码 条数
        param: this.filters
      };
      postTransferAccountsVerifyList(addParams).then(data => {
        this.withdrawalList = data.resultObj.records;
        this.total = data.resultObj.total;
      })
      .catch(err => {
        this.withdrawalList = [];
      });
    },
    withdrawalAuditList() {
      // 回显接口
      var addParams = {
        pageInfo: this.toExaminePage, // 页码 条数
        param: this.newParam
      };
      getTransferOrderNumsInfo(addParams).then(data => {
        this.toExamineList = data.resultObj.records;
        this.toExamineTotal = data.resultObj.total;
      })
      .catch(err => {
        this.toExamineList = [];
      });
    },
    // 审核
    shenheedit(row) {
      this.tixianshenid = row.id; // 选中行id
      this.newParam.transferNum = row.transferNum; // 提现编号
      this.shopName = row.bbName; // 店铺名称
      this.money = row.thisTransferAmount; // 可提现金额

      this.shenmark = "";
      this.isToExamine = true;
      this.withdrawalAuditList();
    },
    // 批量审核
    editFormVisible() {
      if(this.batchliveListArr.length == 0){
        this.$swal({
          text:"请选择需要批量审核的数据 !",
          type:"warning"
        })
        return false;
      }
      this.tixianshenid = '';
      this.shenmark = '';
      this.shenFormVisble = true;
    },
    // 确定审核
    billSubmit(val) {
      if (val== 2 && this.shenmark == "") {
        this.$swal({
          type:"warning",
          text:"请输入审核意见"
        })
        return false;
      }
      var loginParams = {
        ids: this.tixianshenid ? [this.tixianshenid] : this.batchliveListArr,
        examineDesc: this.shenmark,
        dataStatusCode: val,
      };
      postTransferAccountsVerify(loginParams).then(data => {
        this.shenFormVisble = false;
        this.isToExamine = false;
        this.$swal({
            type:"success",
            text: data.resultMsg
        })
        this.init();
      })
    },
    // 复选框
    handleSelectionChange(val) {
      this.batchliveListArr = [];
      val.forEach(element => {
        this.batchliveListArr.push(element.id);
      });
    },
    selectInit(row,index){
      if(row.dataStatusCode == 1){
        return true  //可勾选
      }else{
        return false  //不可勾选
      }
    },
    // 申请时间
    changetime() {
      if( this.value6 + "" == "null" ){
        this.value6 = ["",""]
      }
      this.filters.createDateB = this.value6[0];
      this.filters.createDateE = this.value6[1];
    },
    // 分页
    handleCurrentChange(val) {
      this.pageInfo.pageNum = val;
      this.init();
    },
    // 审核分页
    handleElCol(val) {
      this.toExaminePage.pageNum = val;
      this.withdrawalAuditList();
    },
    //查询
    onSubmit() {
      this.pageInfo.pageNum = 1;
      this.init();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
  cursor: pointer;
}
.draw .draw_toolbar {
  height: auto;
  color: #404040;
}

/* 时间  */
/* .draw_toolbar .line {
  margin-left: 10px;
  line-height: 36px;
} */
/* 时间图标 */
/* .draw_toolbar .line img{
  margin-top:8px
} */
/* 查询按钮 */
.draw_toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
  border-color: #ff4949;
}
/* 内容表格 */
.draw_table {
  min-height: 500px;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  position: relative;
  margin-top: 10px;
}
/* 标题 */
.draw_table section {
  height: 55px;
  line-height: 55px;
  border-bottom: 1px solid #eee;
}
/* 提现审核 */
.draw_table .el-col-22 p {
  width: 60px;
  height: 55px;
 
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.draw_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
/* 表格 */
.draw_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
  font-size: 12px;
}

/* 表格操作 */
.draw_tab .draw_operation p {
  float: left;
  color: #677c9d;
  width: 68px;
  cursor: pointer;
}
.draw_tab .draw_operation p:first-child {
  margin-left: 20%;
}

/* 分页 */
.draw_toolbar_footer {
  position: absolute;
  bottom: 10px;
}

/* 审核操作按钮区域 */
.btnDiv {
  width: 100%;
  margin-top: 20px;
  display: flex;
  flex: 1;
  line-height: 55px;
}
.elFormClass {
  text-align: right;
}
.elFormClass b {
  font-size: 16px;
  margin-right: 16px;
}
</style>


// WEBPACK FOOTER //
// storeCashWithdrawalAudit.vue?cb46d1ac